import * as React from 'react';
import { usePostsContext } from '../contexts/posts';
import { useFiltersContext } from '../contexts/filters';
import Loading from '../widgets/Loading';
const { __ } = wp.i18n;

const Posts = ({ children }) => {
	const {
		posts,
		maxNumPages,
		foundPosts,
		page,
		setPage,
		setLoading,
		loading,
		loadingHeight,
		setLoadingHeight,
	} = usePostsContext();
	const [isLoading, setIsLoading] = React.useState(true);

	const { searchQuery } = useFiltersContext();

	// Create a minimum load time to prevent flickering.
	const lastLoading = React.useRef(false);
	React.useEffect(() => {
		const minLoader = 500;

		if (loading) {
			lastLoading.current = new Date();
			setIsLoading(true);
		} else if (false !== lastLoading.current) {
			const now = new Date();
			const diff = now.getTime() - lastLoading.current.getTime();

			if (diff > minLoader) {
				setIsLoading(false);
			} else {
				setTimeout(() => {
					setIsLoading(false);
				}, minLoader - diff);
			}
		}
	}, [loading]);

	const childrenWithProps = React.Children.map(children, (child) => {
		if (React.isValidElement(child)) {
			return React.cloneElement(child, {
				posts,
				maxNumPages,
				foundPosts,
				page,
				setPage,
				loading,
				loadingHeight,
				setLoading,
				setLoadingHeight,
				isLoading,
				setIsLoading,
			});
		}
		return child;
	});

	let resultCount = '';
	if (searchQuery.length > 0) {
		if (foundPosts > 0) {
			resultCount = (
				<span>
					{foundPosts} Result{foundPosts > 1 && 's'} Found
				</span>
			);
		} else {
			resultCount = <span>{__('No results found', 'wex')}</span>;
		}
	}

	return (
		<>
			<div className="sr-only" aria-live="assertive">
				{resultCount}
			</div>
			<Loading isLoading={isLoading} height={loadingHeight}>
				<div className="pfa-posts">{childrenWithProps}</div>
			</Loading>
		</>
	);
};

Posts.displayName = 'Posts';

export default Posts;
